const ROLES = {
  CUSTOMER: "5ee1f006ba42c8001b2ba73a",
  PARTNER: "5ee1effcba42c8001b2ba66e",
  ADMIN: "5ea9879bdbbba6001aec71b6",
};

export default ROLES;
